module.exports = __webpack_public_path__ + "static/media/interventions-bar.963423e8.svg";